
"use strict";
const $fa7a60d60ed0fb7b$var$backDrop = document.querySelector(".modal__backdrop");
const $fa7a60d60ed0fb7b$var$addTaskModal = document.querySelector(".modal__new-task");
const $fa7a60d60ed0fb7b$var$editTaskModal = document.querySelector(".modal__edit-task");
const $fa7a60d60ed0fb7b$var$deleteTaskModal = document.querySelector(".modal__delete-task");
const $fa7a60d60ed0fb7b$var$weatherModal = document.querySelector(".modal__weather");
const $fa7a60d60ed0fb7b$var$profileModal = document.querySelector(".modal__profile");
const $fa7a60d60ed0fb7b$var$modalForm = document.querySelector(".modal__form");
const $fa7a60d60ed0fb7b$var$addTaskInput = document.querySelector(".modal__task-input");
const $fa7a60d60ed0fb7b$var$usernameInput = document.querySelector(".username-input");
const $fa7a60d60ed0fb7b$var$locationInput = document.querySelector(".location-input");
const $fa7a60d60ed0fb7b$var$editContainer = document.querySelector(".modal__render-edit-container");
const $fa7a60d60ed0fb7b$var$deleteContainer = document.querySelector(".modal__render-delete-container");
const $fa7a60d60ed0fb7b$var$saveBtn = document.querySelector(".modal__btn-save");
const $fa7a60d60ed0fb7b$var$profileSaveBtn = document.querySelector(".modal__btn-profile-save");
const $fa7a60d60ed0fb7b$var$doneBtn = document.querySelectorAll(".modal__btn-done");
const $fa7a60d60ed0fb7b$var$cancelBtn = document.querySelectorAll(".modal__btn-cancel");
const $fa7a60d60ed0fb7b$var$okBtn = document.querySelector(".modal__btn-ok");
$fa7a60d60ed0fb7b$var$modalForm.addEventListener("keydown", function(event) {
    // Stop anything from happening when user presses the enter key
    if (event.key === "Enter") event.preventDefault();
});
///////////////////////////////////////////////
// SAVE BUTTON
///////////////////////////////////////////////
$fa7a60d60ed0fb7b$var$saveBtn.addEventListener("click", function(event) {
    // Object that will be saved into localstorage
    const dataObject = {
        taskDate: Number($54b47fc030b7b21e$export$8ab225cdf6be8954),
        taskMonth: $54b47fc030b7b21e$export$ca000e230c0caa3e.month,
        taskTitle: $fa7a60d60ed0fb7b$var$addTaskInput.value
    };
    // Push object to the end of the main tasks array
    $54b47fc030b7b21e$export$7191f9b9098a3ea4[$54b47fc030b7b21e$export$7191f9b9098a3ea4.length] = dataObject;
    localStorage.setItem("tasks", JSON.stringify($54b47fc030b7b21e$export$7191f9b9098a3ea4));
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "none";
    $fa7a60d60ed0fb7b$var$addTaskModal.style.display = "none";
    // Stop scrolling when modal is open
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
    // Clear input field
    $fa7a60d60ed0fb7b$var$addTaskInput.value = "";
    // Render the calendar with the new data
    $54b47fc030b7b21e$export$2062782c78489ae9();
});
const $fa7a60d60ed0fb7b$export$74fc2f5227cc41bd = function() {
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "block";
    $fa7a60d60ed0fb7b$var$addTaskModal.style.display = "flex";
    $fa7a60d60ed0fb7b$var$addTaskInput.focus();
    // Stop scrolling when modal is open
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
};
const $fa7a60d60ed0fb7b$export$316cd9caae89eb91 = function() {
    // Collects the entire markup to be attached when done
    let markup = "";
    // Counter for the task numbers when rendering dynamically
    let i = 1;
    // Get only the tasks for the day and month you clicked
    const filtered = $54b47fc030b7b21e$export$7191f9b9098a3ea4.filter((task)=>task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month);
    // For each task of selected generate the html markup
    filtered.forEach((task)=>{
        markup += `<div class="modal__task-container">
      <label class="modal__task-label--edit" for="task">Task ${i}:</label>
      <input class="modal__task-input" name="task" type="text" data-task=${i} value="${task.taskTitle}" autocomplete="off" maxlength="30"
      readonly>
      <button class="edit-task-btn" data-task=${i}>Edit</button>
    </div>`;
        i++;
    });
    $fa7a60d60ed0fb7b$var$editContainer.innerHTML = "";
    $fa7a60d60ed0fb7b$var$editContainer.insertAdjacentHTML("afterbegin", markup);
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "block";
    $fa7a60d60ed0fb7b$var$editTaskModal.style.display = "flex";
    // Stop scrolling when modal is open
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
};
const $fa7a60d60ed0fb7b$export$dc3d54406d71c4fb = function() {
    // Collects the entire markup to be attached when done
    let markup = "";
    // Counter for the task numbers when rendering dynamically
    let i = 1;
    // Get only the tasks for the day and month you clicked
    const filtered = $54b47fc030b7b21e$export$7191f9b9098a3ea4.filter((task)=>task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month);
    // For each task of selected generate the html markup
    filtered.forEach((task)=>{
        markup += `<div class="modal__task-container">
      <label class="modal__task-label--delete" for="task">Task ${i}:</label>
      <input class="modal__task-input" name="task" type="text" data-task=${i} value="${task.taskTitle}" autocomplete="off" maxlength="30"
      readonly>
      <button class="delete-task-btn" data-task=${i}>Delete</button>
    </div>`;
        i++;
    });
    $fa7a60d60ed0fb7b$var$deleteContainer.innerHTML = "";
    $fa7a60d60ed0fb7b$var$deleteContainer.insertAdjacentHTML("afterbegin", markup);
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "block";
    $fa7a60d60ed0fb7b$var$deleteTaskModal.style.display = "flex";
    // Stop scrolling when modal is open
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
};
///////////////////////////////////////////////
// OPEN WEATHER MODAL
///////////////////////////////////////////////
const $fa7a60d60ed0fb7b$var$weatherIMG = document.querySelector(".weather__img");
const $fa7a60d60ed0fb7b$var$weatherTemperature = document.querySelector(".weather__temp");
const $fa7a60d60ed0fb7b$var$humidityIMG = document.querySelector(".humidity");
const $fa7a60d60ed0fb7b$var$weatherHumidity = document.querySelector(".humidity__text");
const $fa7a60d60ed0fb7b$var$windIMG = document.querySelector(".wind");
const $fa7a60d60ed0fb7b$var$weatherWind = document.querySelector(".wind__text");
const $fa7a60d60ed0fb7b$var$KEY = "9b3d812c470e4cc4abf95058240901";
const $fa7a60d60ed0fb7b$export$8bcf072155cf9156 = async function() {
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "block";
    $fa7a60d60ed0fb7b$var$weatherModal.style.display = "flex";
    // Stop scrolling when modal is open
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
    try {
        $fa7a60d60ed0fb7b$var$weatherIMG.classList.add("spinner-class");
        let data;
        if (localStorage.getItem("profile")) {
            const profile = JSON.parse(localStorage.getItem("profile"));
            data = await $fa7a60d60ed0fb7b$export$f4026f193782c6da(profile.location);
            $fa7a60d60ed0fb7b$var$showElements();
            if (!data.current) throw new Error("Invalid location in your profile");
            else {
                // Apply the data to the markup elements
                $fa7a60d60ed0fb7b$var$weatherIMG.classList.remove("spinner-class");
                $fa7a60d60ed0fb7b$var$weatherIMG.src = $54b47fc030b7b21e$export$6c248343c6ec5612[data.current.condition.code];
                $fa7a60d60ed0fb7b$var$weatherTemperature.textContent = `${data.current.temp_c}\xb0C`;
                $fa7a60d60ed0fb7b$var$weatherHumidity.textContent = `${data.current.humidity}%`;
                $fa7a60d60ed0fb7b$var$weatherWind.textContent = `${data.current.wind_mph} mph`;
            }
        } else if (!localStorage.getItem("profile")) $fa7a60d60ed0fb7b$var$weatherMarkup("Enter a location into your profile (top left)");
    } catch (error) {
        console.error(error);
        $fa7a60d60ed0fb7b$var$weatherMarkup("Invalid location! Please change your location to a valid city or country name");
    }
};
const $fa7a60d60ed0fb7b$var$weatherMarkup = function(message) {
    $fa7a60d60ed0fb7b$var$weatherIMG.style.display = "none";
    $fa7a60d60ed0fb7b$var$weatherTemperature.style.fontSize = "2.4rem";
    $fa7a60d60ed0fb7b$var$weatherTemperature.textContent = message;
    $fa7a60d60ed0fb7b$var$humidityIMG.style.display = "none";
    $fa7a60d60ed0fb7b$var$weatherHumidity.style.display = "none";
    $fa7a60d60ed0fb7b$var$windIMG.style.display = "none";
    $fa7a60d60ed0fb7b$var$weatherWind.style.display = "none";
};
const $fa7a60d60ed0fb7b$var$showElements = function() {
    $fa7a60d60ed0fb7b$var$weatherIMG.style.display = "block";
    $fa7a60d60ed0fb7b$var$humidityIMG.style.display = "block";
    $fa7a60d60ed0fb7b$var$weatherHumidity.style.display = "inline-block";
    $fa7a60d60ed0fb7b$var$windIMG.style.display = "block";
    $fa7a60d60ed0fb7b$var$weatherWind.style.display = "inline-block";
};
const $fa7a60d60ed0fb7b$export$f4026f193782c6da = async function(location) {
    try {
        // Request data from weatherAPI
        const apiJSON = await fetch(`https://api.weatherapi.com/v1/current.json?key=${$fa7a60d60ed0fb7b$var$KEY}&q=${location}&aqi=no`);
        // Check if data has succesfully been retrieved
        if (!apiJSON.ok) throw new Error("Invalid request, change location and try again");
        // Convert data from JSON format
        const data = await apiJSON.json();
        console.log(data);
        return data;
    } catch (error) {
        // If something goes wrong crashes are caught here
        console.error(error);
    }
};
const $fa7a60d60ed0fb7b$export$61e0beb31520f9bf = function() {
    $54b47fc030b7b21e$export$4882ae973e0491e = JSON.parse(localStorage.getItem("profile"));
    if (localStorage.getItem("profile")) {
        $fa7a60d60ed0fb7b$var$usernameInput.placeholder = $54b47fc030b7b21e$export$4882ae973e0491e.username;
        $fa7a60d60ed0fb7b$var$locationInput.placeholder = $54b47fc030b7b21e$export$4882ae973e0491e.location;
    } else {
        $fa7a60d60ed0fb7b$var$usernameInput.placeholder = "Username";
        $fa7a60d60ed0fb7b$var$locationInput.placeholder = "Location";
    }
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "block";
    $fa7a60d60ed0fb7b$var$profileModal.style.display = "flex";
    $fa7a60d60ed0fb7b$var$usernameInput.focus();
    // Stop scrolling when modal is open
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
};
///////////////////////////////////////////////
// PROFILE SAVE BUTTON
///////////////////////////////////////////////
const $fa7a60d60ed0fb7b$var$profileWeatherImg = document.querySelector(".profile__weather-img");
$fa7a60d60ed0fb7b$var$profileSaveBtn.addEventListener("click", function() {
    const dataObject = {
        username: localStorage.getItem("profile") && $fa7a60d60ed0fb7b$var$usernameInput.value === "" ? $54b47fc030b7b21e$export$4882ae973e0491e.username : $fa7a60d60ed0fb7b$var$usernameInput.value,
        location: localStorage.getItem("profile") && $fa7a60d60ed0fb7b$var$locationInput.value === "" ? $54b47fc030b7b21e$export$4882ae973e0491e.location : $fa7a60d60ed0fb7b$var$locationInput.value
    };
    localStorage.setItem("profile", JSON.stringify(dataObject));
    $54b47fc030b7b21e$export$8482b82e7f2d1170();
    $54b47fc030b7b21e$export$a0970d3fb899bad3();
    $fa7a60d60ed0fb7b$var$profileWeatherImg.style.display = "block";
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "none";
    $fa7a60d60ed0fb7b$var$profileModal.style.display = "none";
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
    // Clear input field
    $fa7a60d60ed0fb7b$var$usernameInput.value = "";
    $fa7a60d60ed0fb7b$var$locationInput.value = "";
});
///////////////////////////////////////////////
// CANCEL BUTTON
///////////////////////////////////////////////
$fa7a60d60ed0fb7b$var$cancelBtn.forEach((btn)=>{
    btn.addEventListener("click", function() {
        $fa7a60d60ed0fb7b$var$backDrop.style.display = "none";
        $fa7a60d60ed0fb7b$var$addTaskModal.style.display = "none";
        $fa7a60d60ed0fb7b$var$editTaskModal.style.display = "none";
        $fa7a60d60ed0fb7b$var$deleteTaskModal.style.display = "none";
        $fa7a60d60ed0fb7b$var$profileModal.style.display = "none";
        document.body.style.overflow = "auto";
        document.body.style.height = "auto";
    });
});
///////////////////////////////////////////////
// DONE BUTTON
///////////////////////////////////////////////
$fa7a60d60ed0fb7b$var$doneBtn.forEach((btn)=>{
    btn.addEventListener("click", function() {
        $fa7a60d60ed0fb7b$var$backDrop.style.display = "none";
        $fa7a60d60ed0fb7b$var$addTaskModal.style.display = "none";
        $fa7a60d60ed0fb7b$var$editTaskModal.style.display = "none";
        $fa7a60d60ed0fb7b$var$deleteTaskModal.style.display = "none";
        document.body.style.overflow = "auto";
        document.body.style.height = "auto";
        // Render the calendar with the new data
        $54b47fc030b7b21e$export$2062782c78489ae9();
    });
});
///////////////////////////////////////////////
// OK BUTTON
///////////////////////////////////////////////
$fa7a60d60ed0fb7b$var$okBtn.addEventListener("click", function() {
    $fa7a60d60ed0fb7b$var$backDrop.style.display = "none";
    $fa7a60d60ed0fb7b$var$weatherModal.style.display = "none";
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
});


"use strict";
const $54b47fc030b7b21e$var$calendar = document.querySelector(".organiser__dates");
const $54b47fc030b7b21e$var$monthYear = document.getElementById("month-year");
const $54b47fc030b7b21e$var$btnPrevious = document.querySelector(".month__button--previous");
const $54b47fc030b7b21e$var$btnNext = document.querySelector(".month__button--next");
const $54b47fc030b7b21e$var$avatarEl = document.querySelector(".profile__avatar");
const $54b47fc030b7b21e$var$usernameEl = document.querySelector(".profile__username");
const $54b47fc030b7b21e$var$locationEl = document.querySelector(".profile__location");
const $54b47fc030b7b21e$var$profileWeatherDiv = document.querySelector(".profile__weather");
const $54b47fc030b7b21e$var$profileWeatherImg = document.querySelector(".profile__weather-img");
const $54b47fc030b7b21e$var$profileWeatherText = document.querySelector(".profile__weather-text");
const $54b47fc030b7b21e$var$weekdaysArray = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
let $54b47fc030b7b21e$var$currentDate = new Date();
let $54b47fc030b7b21e$var$originalDate = new Date().getDate();
let $54b47fc030b7b21e$export$8ab225cdf6be8954;
let $54b47fc030b7b21e$export$7191f9b9098a3ea4 = localStorage.getItem("tasks") ? JSON.parse(localStorage.getItem("tasks")) : [];
let $54b47fc030b7b21e$export$4882ae973e0491e = localStorage.getItem("profile") ? JSON.parse(localStorage.getItem("profile")) : [];
const $54b47fc030b7b21e$export$ca000e230c0caa3e = {};
// Gets all the data for the date you are working with
const $54b47fc030b7b21e$var$getDate = function() {
    $54b47fc030b7b21e$export$ca000e230c0caa3e.day = $54b47fc030b7b21e$var$currentDate.getDay();
    $54b47fc030b7b21e$export$ca000e230c0caa3e.month = $54b47fc030b7b21e$var$currentDate.getMonth();
    $54b47fc030b7b21e$export$ca000e230c0caa3e.year = $54b47fc030b7b21e$var$currentDate.getFullYear();
    $54b47fc030b7b21e$export$ca000e230c0caa3e.daysInMonth = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year, $54b47fc030b7b21e$export$ca000e230c0caa3e.month + 1, 0).getDate();
    $54b47fc030b7b21e$export$ca000e230c0caa3e.firstDayOfMonth = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year, $54b47fc030b7b21e$export$ca000e230c0caa3e.month, 1);
    $54b47fc030b7b21e$export$ca000e230c0caa3e.dateString = $54b47fc030b7b21e$export$ca000e230c0caa3e.firstDayOfMonth.toLocaleDateString("en-UK", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
    });
    $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays = $54b47fc030b7b21e$var$weekdaysArray.indexOf($54b47fc030b7b21e$export$ca000e230c0caa3e.dateString.split(", ")[0]);
};
// Adds a class modifier depending on what date it is currently
const $54b47fc030b7b21e$var$addCurrentMarkup = function(i) {
    if (i === $54b47fc030b7b21e$var$originalDate && $54b47fc030b7b21e$export$ca000e230c0caa3e.month === new Date().getMonth()) return `--current`;
    else return "";
};
// Returns the html markup needed for rendering the appropriate task titles
const $54b47fc030b7b21e$var$renderTaskTitle = function(i, line) {
    const filtered = $54b47fc030b7b21e$export$7191f9b9098a3ea4.filter((task)=>{
        return task.taskDate === i && $54b47fc030b7b21e$export$ca000e230c0caa3e.month === task.taskMonth;
    });
    if (filtered[line] && filtered[line].taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return `${filtered[line].taskTitle}`;
    else return "";
};
// Renders the add task button at the top of the dates, unless date has passed
const $54b47fc030b7b21e$var$renderAddTaskBtn = function(i) {
    if (i < $54b47fc030b7b21e$var$originalDate) return "";
    else return `<button class="tasks__btn tasks__btn--add" aria-label="button to add task for this date" data-date="${i}"><i class="fa-solid fa-plus"></i></button>`;
};
// Renders the edit button at the top of the dates, unless there are no tasks for that date
const $54b47fc030b7b21e$var$renderEditTaskBtn = function(i) {
    if ($54b47fc030b7b21e$export$7191f9b9098a3ea4.some((task)=>task.taskDate === i)) return `<button class="tasks__btn tasks__btn--edit" aria-label="button to edit existing tasks for this date" data-date="${i}"><i class="fa-solid fa-pen-to-square"></i></button>`;
    else return "";
};
// Renders the delete button at the top of the dates, unless there are no tasks for that date
const $54b47fc030b7b21e$var$renderDeleteTaskBtn = function(i) {
    if ($54b47fc030b7b21e$export$7191f9b9098a3ea4.some((task)=>task.taskDate === i)) return `<button class="tasks__btn tasks__btn--delete" aria-label="button to delete some tasks for this date" data-date="${i}"><i class="fa-solid fa-trash"></i></button>`;
    else return "";
};
// Renders the weather button at the top of every date, which will get the weather info from API and display it
const $54b47fc030b7b21e$var$renderWeatherBtn = function(i) {
    if (i === $54b47fc030b7b21e$var$originalDate) return `<button class="tasks__btn tasks__btn--weather" aria-label="button to see current weather for this date" data-date="${i}"><i class="fa-solid fa-cloud-sun"></i></button>`;
    else return "";
};
// Generates all the html markup for all the dates of the month
const $54b47fc030b7b21e$var$renderDates = function() {
    // Collects all the markup when finished
    let markup = "";
    for(let i = 1; i <= $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays + $54b47fc030b7b21e$export$ca000e230c0caa3e.daysInMonth; i++)if (i > $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays) markup += `
      <div class="tasks">
          <div class="tasks__date${$54b47fc030b7b21e$var$addCurrentMarkup(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays)}"><span>${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}</span></div>
          <div class="tasks__divider">
            ${$54b47fc030b7b21e$var$renderWeatherBtn(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays)}
            ${$54b47fc030b7b21e$var$renderAddTaskBtn(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays)}
            ${$54b47fc030b7b21e$var$renderEditTaskBtn(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays)}
            ${$54b47fc030b7b21e$var$renderDeleteTaskBtn(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays)}
          </div>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-1-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-1-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-1-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 0) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 0) : ""}</label>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-2-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-2-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-2-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 1) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 1) : ""}</label>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-3-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-3-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-3-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 2) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 2) : ""}</label>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-4-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-4-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-4-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 3) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 3) : ""}</label>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-5-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-5-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-5-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 4) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 4) : ""}</label>
          <div class="tasks__checkbox">
            <input type="checkbox" name="checkbox" id="task-6-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">
          </div>
          <label class="tasks__todo" for="task-6-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}" data-task="task-6-${i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays}">${$54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 5) ? $54b47fc030b7b21e$var$renderTaskTitle(i - $54b47fc030b7b21e$export$ca000e230c0caa3e.paddingDays, 5) : ""}</label>
        </div>
      `;
    else markup += `
      <div class="padding"></div>
      `;
    // Clear and insert html markup into the calendar
    $54b47fc030b7b21e$var$calendar.innerHTML = "";
    $54b47fc030b7b21e$var$calendar.insertAdjacentHTML("afterbegin", markup);
};
// Renders and updates the current month and year text at the top of the calendar
const $54b47fc030b7b21e$var$renderMonthYear = function() {
    $54b47fc030b7b21e$var$monthYear.textContent = `${new Intl.DateTimeFormat("en-UK", {
        month: "long"
    }).format($54b47fc030b7b21e$var$currentDate)} ${$54b47fc030b7b21e$var$currentDate.getFullYear()}`;
};
const $54b47fc030b7b21e$export$2062782c78489ae9 = function() {
    $54b47fc030b7b21e$export$7191f9b9098a3ea4 = localStorage.getItem("tasks") ? JSON.parse(localStorage.getItem("tasks")) : [];
    // Renders and updates the current month and year text at the top of the calendar
    $54b47fc030b7b21e$var$renderMonthYear();
    // Gets the current (or requested by previous or next month buttons) dates and saves it in state object
    $54b47fc030b7b21e$var$getDate();
    // Renders all the markup for each date of currently viewed month
    $54b47fc030b7b21e$var$renderDates();
    // Attaches eventlisteners to the add, edit, and delete buttons
    $54b47fc030b7b21e$var$attachBtnHandler();
    // Renders the css styles according to whether the checkbox is checked or not
    $54b47fc030b7b21e$var$attachCheckBoxHandler();
};
// Button for going through the months - Previous Month
$54b47fc030b7b21e$var$btnPrevious.addEventListener("click", function() {
    if ($54b47fc030b7b21e$var$currentDate.getMonth() === 0) $54b47fc030b7b21e$var$currentDate = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year - 1, 11);
    else $54b47fc030b7b21e$var$currentDate = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year, $54b47fc030b7b21e$export$ca000e230c0caa3e.month - 1);
    $54b47fc030b7b21e$export$2062782c78489ae9();
});
// Button for going through the months - Next Month
$54b47fc030b7b21e$var$btnNext.addEventListener("click", function() {
    if ($54b47fc030b7b21e$var$currentDate.getMonth() === 11) $54b47fc030b7b21e$var$currentDate = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year + 1, 0);
    else $54b47fc030b7b21e$var$currentDate = new Date($54b47fc030b7b21e$export$ca000e230c0caa3e.year, $54b47fc030b7b21e$export$ca000e230c0caa3e.month + 1);
    $54b47fc030b7b21e$export$2062782c78489ae9();
});
////////////////////////////////////
// Function which adds all the eventlisteners to the buttons on every date
////////////////////////////////////
// Add eventlisteners to all the "add task" buttons on all the dates
// Also collects the dataset for the date of the clicked button
const $54b47fc030b7b21e$var$attachBtnHandler = function() {
    const addTaskBtns = document.querySelectorAll(".tasks__btn--add");
    const editTaskBtns = document.querySelectorAll(".tasks__btn--edit");
    const deleteTaskBtns = document.querySelectorAll(".tasks__btn--delete");
    const weatherBtns = document.querySelectorAll(".tasks__btn--weather");
    addTaskBtns.forEach((btn)=>btn.addEventListener("click", function(event) {
            // Get the dataset from the button itself when clicking the icon within the button
            $54b47fc030b7b21e$export$8ab225cdf6be8954 = event.target.closest(".tasks__btn--add").dataset.date;
            // Opens the add task modal, creates object of date info and task title, and saves to localstorage
            $fa7a60d60ed0fb7b$export$74fc2f5227cc41bd();
        }));
    editTaskBtns.forEach((btn)=>{
        btn.addEventListener("click", function(event) {
            // Get the dataset from the button itself when clicking the icon within the button
            $54b47fc030b7b21e$export$8ab225cdf6be8954 = event.target.closest(".tasks__btn--edit").dataset.date;
            // Opens the edit modal, filters, and renders tasks for that day inside the modal
            $fa7a60d60ed0fb7b$export$316cd9caae89eb91();
            // Checks which tasks have been edited and saves them into localstorage
            $54b47fc030b7b21e$var$editTaskHandler();
        });
    });
    deleteTaskBtns.forEach((btn)=>{
        btn.addEventListener("click", function(event) {
            // Get the dataset from the button itself when clicking the icon within the button
            $54b47fc030b7b21e$export$8ab225cdf6be8954 = event.target.closest(".tasks__btn--delete").dataset.date;
            // Opens the delete modal, filters, and renders tasks for that day inside the modal
            $fa7a60d60ed0fb7b$export$dc3d54406d71c4fb();
            // Checks which tasks have been deleted and saves changes into localstorage
            $54b47fc030b7b21e$var$deleteTaskHandler();
        });
    });
    weatherBtns.forEach((btn)=>{
        btn.addEventListener("click", function(event) {
            // Get the dataset from the button itself when clicking the icon within the button
            $54b47fc030b7b21e$export$8ab225cdf6be8954 = event.target.closest(".tasks__btn--weather").dataset.date;
            // Opens the weather modal, and renders the weather from an API (openweathermap) for that day inside the modal
            $fa7a60d60ed0fb7b$export$8bcf072155cf9156();
        });
    });
};
const $54b47fc030b7b21e$var$editTaskHandler = function() {
    // Select the dynamically rendered (by the modal.openEditTask) btns and inputs inside the edit modal
    const editTaskBtns = document.querySelectorAll(".edit-task-btn");
    const taskInputs = document.querySelectorAll(".modal__task-input");
    // Original and new values for the task titles to compare and update
    let originalValue;
    let newValue;
    editTaskBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            if (btn.textContent === "Edit") {
                btn.textContent = "Save";
                taskInputs.forEach((input)=>{
                    // Sets the inputs from readonly to editable
                    if (btn.dataset.task === input.dataset.task && input.hasAttribute("readonly")) {
                        // Sets original value to be compared later
                        originalValue = input.value;
                        input.removeAttribute("readonly");
                    }
                });
            // Sets inputs back to readonly, compares each input with original values and updates the changed titles, and finally updates localstorage
            } else if (btn.textContent === "Save") {
                btn.textContent = "Edit";
                taskInputs.forEach((input)=>{
                    if (btn.dataset.task === input.dataset.task && !input.hasAttribute("readonly")) {
                        // Sets new value to replace with in tasks later
                        newValue = input.value;
                        const mappedTasks = $54b47fc030b7b21e$export$7191f9b9098a3ea4.map((task)=>{
                            if (task.taskDate !== Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return task;
                            else if (task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskTitle !== originalValue && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return task;
                            else if (task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskTitle === originalValue && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) {
                                task.taskTitle = newValue;
                                return task;
                            }
                        });
                        input.setAttribute("readonly", "readonly");
                        localStorage.setItem("tasks", JSON.stringify(mappedTasks));
                    }
                });
            }
        });
    });
};
const $54b47fc030b7b21e$var$deleteTaskHandler = function() {
    // Select the dynamically rendered (by the modal.openDeleteTask) btns and inputs inside the delete task modal
    const deleteTaskBtns = document.querySelectorAll(".delete-task-btn");
    const taskInputs = document.querySelectorAll(".modal__task-input");
    let originalValueArray = [];
    deleteTaskBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            if (btn.textContent === "Delete") btn.textContent = "Confirm";
            else if (btn.textContent === "Confirm") {
                btn.textContent = "Delete";
                taskInputs.forEach((item)=>{
                    if (btn.dataset.task === item.dataset.task) {
                        // After confirm is clicked this value will be added to array which will later be used to filter out these to be deteled tasks from the main list of tasks
                        originalValueArray.push(item.value);
                        // After confirming deletion set input and button to display none
                        btn.style.display = "none";
                        item.style.display = "none";
                    }
                    const filteredTasks = $54b47fc030b7b21e$export$7191f9b9098a3ea4.filter((task)=>{
                        if (task.taskDate !== Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return task;
                        else if (task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && !originalValueArray.some((item)=>item === task.taskTitle) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return task;
                        else if (task.taskDate === Number($54b47fc030b7b21e$export$8ab225cdf6be8954) && originalValueArray.some((item)=>item === task.taskTitle) && task.taskMonth === $54b47fc030b7b21e$export$ca000e230c0caa3e.month) return;
                    });
                    localStorage.setItem("tasks", JSON.stringify(filteredTasks));
                });
            }
        });
    });
};
// Listen to and get info from the checkboxes clicked
const $54b47fc030b7b21e$var$attachCheckBoxHandler = function() {
    const checkBox = document.querySelectorAll('input[type="checkbox"]');
    const taskLabel = document.querySelectorAll(".tasks__todo");
    checkBox.forEach((box)=>box.addEventListener("change", function() {
            if (this.checked) taskLabel.forEach((label)=>{
                // Label dataset and checkbox id have matching values representing the month and date
                if (label.dataset.task === this.id) {
                    label.style.opacity = 0.5;
                    label.style.textDecoration = "line-through";
                    // Traverses the DOM until it finds the textContent for the task
                    const data = this.parentElement.nextElementSibling.textContent;
                    // Sets the checked status for this task in the localstorage
                    $54b47fc030b7b21e$var$addCheckedStatus(data, true);
                }
            });
            else taskLabel.forEach((label)=>{
                // Label dataset and checkbox id have matching values representing the month and date
                if (label.dataset.task === this.id) {
                    label.style.opacity = 1;
                    label.style.textDecoration = "none";
                    // Traverses the DOM until it finds the textContent for the task
                    const data = this.parentElement.nextElementSibling.textContent;
                    // Sets the checked status for this task in the localstorage
                    $54b47fc030b7b21e$var$addCheckedStatus(data, false);
                }
            });
        }));
    checkBox.forEach((box)=>{
        const data = box.parentElement.nextElementSibling.textContent;
        $54b47fc030b7b21e$export$7191f9b9098a3ea4.forEach((task)=>{
            if (task.taskTitle === data && task.checked === true) {
                box.setAttribute("checked", "");
                taskLabel.forEach((label)=>{
                    if (label.textContent === data) {
                        label.style.opacity = 0.5;
                        label.style.textDecoration = "line-through";
                    }
                });
            }
        });
    });
};
const $54b47fc030b7b21e$var$addCheckedStatus = function(data, status) {
    $54b47fc030b7b21e$export$7191f9b9098a3ea4.forEach((task)=>{
        if (task.taskTitle === data) {
            task.checked = status;
            localStorage.setItem("tasks", JSON.stringify($54b47fc030b7b21e$export$7191f9b9098a3ea4));
        }
    });
};
////////////////////////////////////
// PROFILE SECTION
////////////////////////////////////
$54b47fc030b7b21e$var$avatarEl.addEventListener("click", function() {
    $fa7a60d60ed0fb7b$export$61e0beb31520f9bf();
});
const $54b47fc030b7b21e$export$8482b82e7f2d1170 = function() {
    $54b47fc030b7b21e$export$4882ae973e0491e = JSON.parse(localStorage.getItem("profile"));
    if (localStorage.getItem("profile")) {
        $54b47fc030b7b21e$var$usernameEl.textContent = $54b47fc030b7b21e$export$4882ae973e0491e.username;
        $54b47fc030b7b21e$var$locationEl.textContent = $54b47fc030b7b21e$export$4882ae973e0491e.location;
    } else {
        $54b47fc030b7b21e$var$usernameEl.textContent = "User";
        $54b47fc030b7b21e$var$locationEl.textContent = "Location";
    }
};
const $54b47fc030b7b21e$export$a0970d3fb899bad3 = async function() {
    try {
        $54b47fc030b7b21e$var$profileWeatherImg.classList.add("spinner-class");
        let data;
        if (localStorage.getItem("profile")) {
            const profile = JSON.parse(localStorage.getItem("profile"));
            data = await $fa7a60d60ed0fb7b$export$f4026f193782c6da(profile.location);
            if (!data.current) throw new Error("Invalid location in your profile");
            else {
                // Apply the data to the markup elements
                $54b47fc030b7b21e$var$profileWeatherImg.classList.remove("spinner-class");
                $54b47fc030b7b21e$var$profileWeatherImg.src = $54b47fc030b7b21e$export$6c248343c6ec5612[data.current.condition.code];
                $54b47fc030b7b21e$var$profileWeatherText.textContent = `${data.current.temp_c}\xb0C`;
            }
        } else if (!localStorage.getItem("profile")) {
            $54b47fc030b7b21e$var$profileWeatherImg.classList.remove("spinner-class");
            $54b47fc030b7b21e$var$profileWeatherImg.style.display = "none";
            $54b47fc030b7b21e$var$profileWeatherText.textContent = "No Location";
        }
    } catch (error) {
        console.error(error);
        $54b47fc030b7b21e$var$profileWeatherImg.classList.remove("spinner-class");
        $54b47fc030b7b21e$var$profileWeatherImg.style.display = "none";
        $54b47fc030b7b21e$var$profileWeatherText.textContent = "Invalid Location";
    }
};
const $54b47fc030b7b21e$export$6c248343c6ec5612 = {
    1000: "/weather/clear-day.svg",
    1003: "/weather/partly-cloudy-day.svg",
    1006: "/weather/cloudy.svg",
    1009: "/weather/overcast.svg",
    1030: "/weather/mist.svg",
    1063: "/weather/partly-cloudy-day-rain.svg",
    1066: "/weather/partly-cloudy-day-snow.svg",
    1069: "/weather/partly-cloudy-day-sleet.svg",
    1072: "/weather/partly-cloudy-day-hail.svg",
    1087: "/weather/thunderstorms-day.svg",
    1114: "/weather/snow.svg",
    1117: "/weather/extreme-snow.svg",
    1135: "/weather/fog.svg",
    1147: "/weather/overcast-fog.svg",
    1150: "/weather/overcast-day-drizzle.svg",
    1153: "/weather/drizzle.svg",
    1168: "/weather/hail.svg",
    1171: "/weather/hail.svg",
    1180: "/weather/partly-cloudy-day-rain.svg",
    1183: "/weather/drizzle.svg",
    1186: "/weather/rain.svg",
    1189: "/weather/rain.svg",
    1192: "/weather/overcast-rain.svg",
    1195: "/weather/overcast-rain.svg",
    1198: "/weather/hail.svg",
    1201: "/weather/hail.svg",
    1204: "/weather/sleet.svg",
    1207: "/weather/extreme-sleet.svg",
    1210: "/weather/partly-cloudy-day-snow.svg",
    1213: "/weather/snow.svg",
    1216: "/weather/partly-cloudy-day-snow.svg",
    1219: "/weather/snow.svg",
    1222: "/weather/overcast-snow.svg",
    1225: "/weather/extreme-snow.svg",
    1237: "/weather/hail.svg",
    1240: "/weather/rain.svg",
    1243: "/weather/extreme-rain.svg",
    1246: "/weather/extreme-rain.svg",
    1249: "/weather/sleet.svg",
    1252: "/weather/extreme-sleet.svg",
    1255: "/weather/snow.svg",
    1258: "/weather/overcast-snow.svg",
    1261: "/weather/hail.svg",
    1264: "/weather/extreme-hail.svg",
    1273: "/weather/thunderstorms-day-rain.svg",
    1276: "/weather/thunderstorms-extreme-rain.svg",
    1279: "/weather/thunderstorms-day-snow.svg",
    1282: "/weather/thunderstorms-extreme-snow.svg"
};
////////////////////////////////////
// THEME SECTION
////////////////////////////////////
const $54b47fc030b7b21e$var$themeBtns = document.querySelectorAll(".themes__btn");
let $54b47fc030b7b21e$var$themeID = localStorage.getItem("theme") ? JSON.parse(localStorage.getItem("theme")) : "purple";
$54b47fc030b7b21e$var$themeBtns.forEach((btn)=>{
    btn.addEventListener("click", function() {
        localStorage.setItem("theme", JSON.stringify(btn.id));
        $54b47fc030b7b21e$var$loadTheme();
        location.replace(location.href);
    });
});
// Function that loads the theme depending on whether there is one saved in local storage or not
const $54b47fc030b7b21e$var$loadTheme = function() {
    document.documentElement.classList.add($54b47fc030b7b21e$var$themeID);
};
$54b47fc030b7b21e$var$loadTheme();
$54b47fc030b7b21e$export$8482b82e7f2d1170();
$54b47fc030b7b21e$export$a0970d3fb899bad3();
$54b47fc030b7b21e$var$getDate();
$54b47fc030b7b21e$var$renderMonthYear();
$54b47fc030b7b21e$var$renderDates();
$54b47fc030b7b21e$var$attachBtnHandler();
$54b47fc030b7b21e$var$attachCheckBoxHandler();


//# sourceMappingURL=index.5e2b7941.js.map
